export function getFileNameFromURI(uri: string): string {
  return uri.split('/').at(-1) ?? '';
}
